
const getFormattedAmountValue = value => value / 100

export default getFormattedAmountValue
